(function () {
  'use strict';
  const feeIds = new Set(['57492931117382', '57492933542214', '57530656063814', '57530656096582']);
  const prop = (line, key) => (line.properties || {})[key];
  const group = line => prop(line, '_ddm_group');
  const role = line => prop(line, '_ddm_role');
  const defaults = {
    invalid: 'Bitte eine gültige ganze Menge eingeben.',
    child: 'Die Gravur gehört zum Hauptartikel. Bitte ändere die Menge am Hauptartikel oder entferne den Hauptartikel und konfiguriere ihn ohne Gravur neu.',
    incomplete: 'Die Gravur und ihre Kosten passen nicht zusammen. Bitte entferne den betroffenen Artikel mit Gravur und konfiguriere ihn erneut. Die Kasse bleibt bis dahin gesperrt.',
    legacy: 'Bitte den Briefwunder mit Gravur einmal aus dem Warenkorb entfernen und neu konfigurieren, damit Artikel und Gravurkosten sicher verbunden sind.',
    failed: 'Die Warenkorbänderung wurde nicht gespeichert. Bitte erneut versuchen.',
    busy: 'Der Warenkorb wird gespeichert …'
  };
  const messages = typeof window === 'undefined' ? defaults : Object.assign({}, defaults, window.DDM_CART_MESSAGES || {});
  function components(line) {
    try {
      const value = JSON.parse(prop(line, '_ddm_components') || '[]');
      if (!Array.isArray(value)) throw new Error(messages.incomplete);
      return value;
    } catch (_) { throw new Error(messages.incomplete); }
  }
  function validate(cart) {
    const lines = cart.items || [];
    for (const line of lines) {
      if (role(line) === 'parent') {
        const expected = components(line);
        if (!group(line) || expected.length !== 2) throw new Error(messages.incomplete);
        const children = lines.filter(child => group(child) === group(line) && role(child) === 'fee');
        if (children.length !== expected.length) throw new Error(messages.incomplete);
        for (const item of expected) {
          const child = children.find(candidate => String(candidate.variant_id || candidate.id) === String(item.id));
          if (!child || !Number.isInteger(item.ratio) || item.ratio < 1 || child.quantity !== line.quantity * item.ratio) throw new Error(messages.incomplete);
          if (!child.parent_relationship || child.parent_relationship.parent_key !== line.key) throw new Error(messages.incomplete);
        }
      } else if (role(line) === 'fee') {
        if (!lines.some(parent => group(parent) === group(line) && role(parent) === 'parent')) throw new Error(messages.incomplete);
      } else if (prop(line, 'Gravur') && !feeIds.has(String(line.variant_id || line.id)) && /^briefwunder/i.test(line.product_title || line.title || '')) {
        throw new Error(messages.legacy);
      } else if (feeIds.has(String(line.variant_id || line.id)) && /^briefwunder/i.test(prop(line, 'Für') || '')) {
        throw new Error(messages.legacy);
      }
    }
    return cart;
  }
  function plan(cart, key, quantity) {
    if (!Number.isSafeInteger(quantity) || quantity < 0) throw new Error(messages.invalid);
    const line = (cart.items || []).find(item => item.key === key);
    if (!line) throw new Error(messages.failed);
    if (role(line) === 'fee') throw new Error(messages.child);
    const updates = {};
    if (role(line) === 'parent' && quantity > 0) {
      const expected = components(line);
      const children = cart.items.filter(item => group(item) === group(line) && role(item) === 'fee');
      for (const item of expected) {
        const child = children.find(candidate => String(candidate.variant_id || candidate.id) === String(item.id));
        if (!child || !Number.isInteger(item.ratio) || item.ratio < 1) throw new Error(messages.incomplete);
        updates[child.key] = quantity * item.ratio;
      }
    }
    updates[line.key] = quantity;
    return updates;
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { plan, validate }; return; }
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let pending = Promise.resolve();
  let working = false;
  let allowSubmit = false;
  const cartForm = form => form && form.matches('form.cart-page, form.cart-drawer__footer');
  const getCart = async () => {
    const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(messages.failed);
    return response.json();
  };
  function notice(message, error) {
    let box = document.querySelector('[data-ddm-cart-notice]');
    if (!box) {
      box = document.createElement('p');
      box.dataset.ddmCartNotice = '';
      box.style.cssText = 'padding:12px;border:1px solid currentColor;margin:12px 0;font-size:14px;line-height:1.5';
      const host = document.querySelector('cart-drawer[open] .cart-drawer__footer, form.cart-page .cart-recap, cart-drawer .cart-drawer__footer');
      if (host) host.prepend(box);
      else { box.style.cssText += ';position:fixed;bottom:16px;left:16px;right:16px;background:#fff;z-index:9999'; document.body.append(box); }
    }
    box.setAttribute('role', error ? 'alert' : 'status');
    box.style.color = error ? '#9a2e14' : 'inherit';
    box.textContent = message;
    box.hidden = !message;
  }
  function setBusy(value) {
    working = value;
    for (const control of document.querySelectorAll('line-item-quantity input, .cart-page [name="checkout"], .cart-drawer__footer [name="checkout"]')) {
      if (value) { if (!control.disabled) { control.dataset.ddmBusy = ''; control.disabled = true; } }
      else if (control.hasAttribute('data-ddm-busy')) { control.disabled = false; delete control.dataset.ddmBusy; }
    }
    document.documentElement.dispatchEvent(new CustomEvent(value ? 'theme:loading:start' : 'theme:loading:end', { bubbles: true }));
  }
  async function update(key, quantity, render) {
    const before = await getCart();
    const updates = plan(before, key, quantity);
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
    const response = await fetch(root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections: sections.join(',') })
    });
    const after = await response.json();
    if (!response.ok) throw new Error(after.description || messages.failed);
    const original = before.items.find(item => item.key === key);
    const fingerprint = item => JSON.stringify(Object.entries(item.properties || {}).sort(([left], [right]) => left.localeCompare(right)));
    const changed = after.items.find(item => item.key === key) || after.items.find(item => String(item.variant_id || item.id) === String(original.variant_id || original.id) && fingerprint(item) === fingerprint(original));
    if ((changed ? changed.quantity : 0) !== quantity) throw new Error(messages.failed);
    if (changed && role(changed) === 'parent') validate(after);
    if (render) {
      if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') { window.location.reload(); }
      else document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: after } }));
    }
    return after;
  }
  function enqueue(key, quantity, render = true) {
    const operation = pending.catch(() => {}).then(async () => {
      setBusy(true); notice(messages.busy, false);
      try { const cart = await update(key, quantity, render); notice('', false); return cart; }
      catch (error) { notice(error.message || messages.failed, true); throw error; }
      finally { setBusy(false); }
    });
    pending = operation;
    operation.catch(() => {});
    return operation;
  }
  document.addEventListener('change', event => {
    const input = event.target.closest && event.target.closest('line-item-quantity input[data-line-key]');
    if (!input) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (working) return;
    if (!input.checkValidity()) { input.reportValidity(); notice(messages.invalid, true); return; }
    enqueue(input.dataset.lineKey, Number(input.value));
  }, true);
  document.addEventListener('keydown', event => {
    const input = event.target.closest && event.target.closest('line-item-quantity input[data-line-key]');
    if (event.key !== 'Enter' || !input) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (working) return;
    if (!input.checkValidity()) { input.reportValidity(); notice(messages.invalid, true); return; }
    enqueue(input.dataset.lineKey, Number(input.value));
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest && event.target.closest('line-item-quantity a[href*="/cart/change"]');
    if (!link) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (working) return;
    const url = new URL(link.href);
    enqueue(url.searchParams.get('id'), Number(url.searchParams.get('quantity')));
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!cartForm(form) || allowSubmit) return;
    const checkout = event.submitter && event.submitter.name === 'checkout';
    if (!checkout && event.submitter && event.submitter.getAttribute('type') === 'button') return;
    event.preventDefault(); event.stopImmediatePropagation();
    const submitter = event.submitter;
    (async () => {
      await pending;
      let cart = await getCart();
      const seen = new Set();
      for (const input of form.querySelectorAll('input[data-line-key]')) {
        if (!input.getClientRects().length || seen.has(input.dataset.lineKey)) continue;
        seen.add(input.dataset.lineKey);
        if (!input.checkValidity()) { input.reportValidity(); throw new Error(messages.invalid); }
        const line = cart.items.find(item => item.key === input.dataset.lineKey);
        if (line && Number(input.value) !== line.quantity) cart = await enqueue(line.key, Number(input.value), false);
      }
      if (!checkout) { window.location.reload(); return; }
      validate(cart);
      for (const input of form.querySelectorAll('input[data-line-key]')) input.removeAttribute('name');
      allowSubmit = true;
      if (submitter) form.requestSubmit(submitter);
      else form.requestSubmit();
    })().catch(error => notice(error.message || messages.failed, true));
  }, true);
})();
